import { EnumEventName, EventWebPageLoadMetric } from '@calm/evexia-analytics';
import { COOKIE_E2E } from '@calm/web-common/dist/constants';
import { getCookie } from '@calm/web-common/dist/cookies';
import { NextWebVitalsMetric } from 'next/app';
import { AnalyticsDestination } from '../destination/types';
import mapBaseEventProps from '../map-base-event-props';

export default function trackWebVitals(
    metric: NextWebVitalsMetric,
    destinations: AnalyticsDestination[]
) {
    if (metric.label === 'web-vital' && getCookie(COOKIE_E2E) === '') {
        const { name, label, value } = metric;

        const payload: EventWebPageLoadMetric = {
            name,
            label,
            value,
            // `connection` is non-standard (absent in Safari/Firefox), so
            // `effectiveType` is optional at runtime — `speed` is optional too.
            speed: (
                navigator as Navigator & {
                    connection?: { effectiveType?: string };
                }
            ).connection?.effectiveType,
        };
        /*
         * Next's tracking function doesn't have access
         * to environment scope and this function executes
         * before destinations is initialized in analyticsProvider.ts.
         *
         * Wrapping this in a setTimeout allows
         * analyticsProvider to initialize first (and if
         * it's executing in a local environment it will
         * block this tracking request.)
         * */
        setTimeout(() => {
            destinations.forEach((destination) => {
                if (destination.isLoaded()) {
                    destination
                        .track(
                            EnumEventName.WebPageLoadMetric,
                            mapBaseEventProps(payload)
                        )
                        .catch(() => {});
                }
            });
        });
    }
}
